/* @flow */
import * as React from 'react';
import Button from 'components/Button';
import CenteredContainer from 'components/CenteredContainer';
import TitleHeader from 'components/TitleHeader';
import LinkConstants from 'constants/LinkConstants';

export default class CookiesDisabledPage extends React.Component<{}> {
  render() {
    return (
      <CenteredContainer size="medium">
        <TitleHeader
          title="Your browser's cookies are disabled."
          subtext="Remind uses cookies to keep you logged in and to remember your classes and account information. If your cookies are disabled, Remind won't be able to log you into your account."
          image={require('assets/images/admin/AdminLanding/admin-console.svg')}
          imageSize="xxsmall"
          action={<Button href={LinkConstants.ENABLE_COOKIES}>Enable cookies</Button>}
          nullState
        />
      </CenteredContainer>
    );
  }
}
